module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs/databg.png?495753708e1b3a4b87a7bd6188435eb8";